import axiosClient from "./axiosClient";

export class OrdersApiError extends Error {
  constructor(message, status, code) {
    super(message);
    this.name = "OrdersApiError";
    this.status = status;
    this.code = code;
  }
}

function unwrap(response) {
  const envelope = response?.data;
  if (envelope?.success === false) {
    throw new OrdersApiError(
      envelope.message || "Order request failed.",
      response?.status,
      envelope?.data?.code,
    );
  }
  return envelope?.data ?? envelope;
}

function toError(error) {
  if (error instanceof OrdersApiError) return error;
  const response = error?.response;
  return new OrdersApiError(
    response?.data?.message || "Order request failed. Please try again.",
    response?.status,
    response?.data?.data?.code,
  );
}

async function request(config) {
  try {
    return unwrap(await axiosClient({ ...config, __silentGenericToast: true }));
  } catch (error) {
    throw toError(error);
  }
}

export const ordersApi = {
  list: params => request({ method: "get", url: "/commerce/orders", params }),
  get: transactionId =>
    request({ method: "get", url: `/commerce/orders/${transactionId}` }),
  getOperationalStatus: transactionId =>
    request({
      method: "get",
      url: `/commerce/transactions/${transactionId}/operational-status`,
    }),
  transition: (transactionId, payload) =>
    request({
      method: "patch",
      url: `/commerce/transactions/${transactionId}/operational-status`,
      data: payload,
    }),
};
